export default "__VITE_ASSET__DwvQCUA5__"